module.exports = __webpack_public_path__ + "img/tequila-sunrise.7313d314.jpg";